/**
 * Offered when a plane needs a credential and the viewer has none.
 *
 * Authority: bead scope-njw; scope-caw.1 (staff), scope-9xn (customers).
 *
 * Two planes, two prompts, and no shared "sign in" control: the staff prompt
 * leads to Entra and the customer prompt leads to an emailed code, and a single
 * control that decides between them at runtime is the seam where a customer
 * ends up at the tenant sign-in page.
 */
import { t } from '../../shell/i18n.ts'

export default function SignInRequired({ plane }: { readonly plane: 'customer' | 'staff' }) {
  const heading = plane === 'staff' ? t('signIn.staff.heading') : t('signIn.customer.heading')
  const body = plane === 'staff' ? t('signIn.staff.body') : t('signIn.customer.body')

  return (
    <article className="sign-in">
      <h1>{heading}</h1>
      <p>{body}</p>
    </article>
  )
}
